// Petit carillon de notification généré via Web Audio API — pas besoin de
// fichier audio externe. Les navigateurs bloquent l'audio tant qu'aucune
// interaction utilisateur n'a eu lieu sur la page ; `unlockAudio` doit donc
// être appelé une première fois au clic/tap pour "débloquer" le contexte.

let audioContext = null;

const getContext = () => {
  if (!audioContext) {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    audioContext = new Ctx();
  }
  return audioContext;
};

export const unlockAudio = () => {
  const ctx = getContext();
  if (ctx && ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }
};

export const playNotificationChime = () => {
  const ctx = getContext();
  if (!ctx) return;
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }

  const notes = [880, 1175]; // la5 puis ré6 — deux notes courtes et claires
  notes.forEach((freq, i) => {
    const start = ctx.currentTime + i * 0.14;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = 'sine';
    osc.frequency.setValueAtTime(freq, start);

    gain.gain.setValueAtTime(0, start);
    gain.gain.linearRampToValueAtTime(0.22, start + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, start + 0.32);

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.start(start);
    osc.stop(start + 0.34);
  });
};
